import React, { useState,useEffect } from "react";
import { Button, Input, Typography } from "antd";
import { Icon } from "@iconify/react";
 
interface EmailsColumnProps {
  emails?: string[];
  onChange?: (emails: string[]) => void;
  onErrorChange?: (hasError: boolean) => void; // NEW: tells parent if there's an error
  rowId: number;
}
 
const EmailsColumn: React.FC<EmailsColumnProps> = ({
  emails = [],
  onChange,
  onErrorChange,
  rowId,
}) => {
  const [expandedEmails, setExpandedEmails] = useState<boolean>(false);
  const [emailList, setEmailList] = useState<string[]>(emails);
  const [newEmail, setNewEmail] = useState<string>("");
  const [error, setError] = useState<string>("");
 useEffect(() => {
  setEmailList(emails);
}, [emails]);
  const validateEmail = (email: string): boolean => {
    // Basic email regex
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };
  const handleEmailInputChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
  const value = e.target.value;
  setNewEmail(value);
 
  // Real-time validation
  if (value.trim() && !validateEmail(value.trim())) {
    setError("Please enter a valid email address.");
    onErrorChange?.(true);
  } else {
    setError("");
    onErrorChange?.(false);
  }
};
 
  const handleRemoveEmail = (indexToRemove: number): void => {
    const newEmails = emailList.filter((_, index) => index !== indexToRemove);
    setEmailList(newEmails);
    onChange?.(newEmails);
 
    // Clear error if all remaining emails are valid
    if (newEmails.every(validateEmail)) {
      setError("");
      onErrorChange?.(false);
    }
  };
 
const handleAddMore = (): void => {
  if (!newEmail.trim()) {
    setError("Please enter an email.");
    onErrorChange?.(true);
    return;
  }
 
  // Remove this validation since it's now handled in real-time
  // if (!validateEmail(newEmail.trim())) {
  //   setError("Please enter a valid email address.");
  //   onErrorChange?.(true);
  //   return;
  // }
 
  const updated = [...emailList, newEmail.trim()];
  setEmailList(updated);
  onChange?.(updated);
  setNewEmail("");
  setError("");
  onErrorChange?.(false);
};
 
  const displayedEmails = expandedEmails ? emailList : emailList.slice(0, 1);
  const hiddenCount = emailList.length - displayedEmails.length;
 
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center gap-2">
        {displayedEmails.map((email, index) => (
          <div
            key={index}
            className="inline-flex items-center bg-[#FAF5FF] rounded-md py-1 pr-1 pl-3"
          >
            <span className="text-gray-900 text-sm mr-2">{email}</span>
            <Button
              type="text"
              onClick={() => handleRemoveEmail(index)}
              className="flex items-center justify-center p-0 min-w-[20px] h-5 hover:bg-transparent"
            >
              <Icon
                icon="mdi:close"
                className="text-gray-500 hover:text-gray-700"
                width="16"
              />
            </Button>
          </div>
        ))}
 
        {!expandedEmails && hiddenCount > 0 && (
          <Button
            type="ghost"
            onClick={() => setExpandedEmails(true)}
            className="px-0 h-auto text-purple-500 hover:text-purple-600"
          >
            +{hiddenCount} more
          </Button>
        )}
      </div>
 
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <Input
            type="email"
            placeholder="michelle.rivera@example.com"
            name={`new-email-${rowId}`}
            id={`new-email-${rowId}`}
            autoComplete="new-email"
            value={newEmail}
            onChange={handleEmailInputChange}
            className="border-dashed"
            style={{ flexGrow: 1 }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleAddMore();
              }
            }}
          />
 
          <div className="hover:bg-[#FAF5FF] inline-block">
            <Button
              type="link"
              onClick={handleAddMore}
              className="text-pink-500 hover:text-pink-600 flex items-center gap-1 whitespace-nowrap"
              icon={<Icon icon="mdi:plus" />}
            >
              Add more people
            </Button>
          </div>
        </div>
 
        {error && (
          <Typography.Text type="danger" className="text-xs">
            {error}
          </Typography.Text>
        )}
      </div>
    </div>
  );
};
 
export default EmailsColumn;
 
 